import { PrReqOrg, PrReqInd } from '@/types/prReqType';
import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';
import headerObject from '@/types/headerObj';

const localHost = apiUrl;

const endPoint = 'fetchPRsForUser/';
const url = localHost + endPoint;

export const fetchPRsForUserOrg = async (
  req: PrReqOrg,
  headerObj?: headerObject
) => {
  if (!req.UserUUID) {
    return null;
  }

  if (!req.OrganizationUUID) {
    return null;
  }

  try {
    const res = await postWithAuth(
      url,
      {
        UserUUID: req.UserUUID,
        OrganizationUUID: req.OrganizationUUID,
        Source: req.Source,
      },
      {
        headers: {
          ...headerObj,
        },
      }
    );
    const data = JSON.parse(await res.json());
    const prs = data.PullRequests;
    return prs;
  } catch (err) {
    console.error(err);
  }
};

export const fetchPRsForUserInd = async (
  req: PrReqInd,
  headerObj?: headerObject
) => {
  if (!req.UserUUID) {
    return null;
  }

  try {
    const res = await postWithAuth(
      url,
      {
        RepositoryUUID: req.RepositoryUUID,
        UserUUID: req.UserUUID,
        Source: req.Source,
      },
      {
        headers: {
          ...headerObj,
        },
      }
    );
    const data = JSON.parse(await res.json());
    const prs = data.PullRequests;
    return prs;
  } catch (err) {
    console.error(err);
  }
};

export const fetchPRsForLoggedOutUser = async (
  reponame: string,
  headerObj?: headerObject
) => {
  try {
    const res = await postWithAuth(
      url,
      {
        RepositoryName: reponame,
      },
      {
        headers: {
          ...headerObj,
        },
      }
    );
    const data = JSON.parse(await res.json());
    const prs = data.PullRequests;
    return prs;
  } catch (err) {
    console.error(err);
  }
};
